import dynamic from "next/dynamic";

export const JobPostingSchema = dynamic(() => import("./component"));
